/* eslint-disable max-lines-per-function */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SheetClose, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { useParams } from 'react-router-dom';
import { AntragForm } from '../EditSheet/content';
import { useAntraege } from '../../hooks/useAntraege';
import { useTranslation } from 'react-i18next';
import { useArbeitszeiten } from '../../hooks/useArbeitszeiten';
import { ArbeitszeitArbeitszeitantragStatus } from '@/gql/graphql';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';

export function AntragSheetWrapper() {
  return <AntragSheet />;
}

export function AntragSheet() {
  const { t } = useTranslation();

  const { year, month, day, antragId } = useParams();
  const date = new Date(`${year}-${month}-${day}`);
  const {
    currentStandort: { id: standortId },
  } = useStandortContext();

  const { antraege, error } = useAntraege(standortId, date);

  const { offeneArbeitszeiten } = useArbeitszeiten(date, standortId);

  const arbeitszeitenArray = Array.isArray(offeneArbeitszeiten)
    ? offeneArbeitszeiten
    : [];
  const antraegeMitArbeitszeit = arbeitszeitenArray.flatMap((arbeitszeit) => {
    if ('antraege' in arbeitszeit) {
      return arbeitszeit.antraege.map((antrag) => ({
        ...antrag,
        arbeitszeitId: arbeitszeit.id,
      }));
    }
    return [];
  });

  const filteredAntraege = (antraegeMitArbeitszeit || []).filter(
    (antrag) => antrag.status !== ArbeitszeitArbeitszeitantragStatus.Neu,
  );

  if (error) {
    return <div>Error: {error}</div>;
  }

  const currentAntrag = antraege.find((antrag) => antrag.id === antragId);
  const currentAntragMitArbeitszeit = antraegeMitArbeitszeit.find(
    (antrag) => antrag.id === antragId,
  );

  return (
    <>
      <SheetHeader className="bg-neutrals-N200 mb-4">
        <SheetTitle className="flex items-center justify-between p-4">
          <SheetClose className="flex items-center gap-2">
            <FontAwesomeIcon
              className="text-primary-blue-B500"
              icon={faArrowLeft}
            />
            <span className="text-sm text-neutrals-N800">
              {t('domain.arbeitszeiten.antrag.bearbeiten')}
            </span>
          </SheetClose>
        </SheetTitle>
      </SheetHeader>
      <AntragForm
        currentAntrag={currentAntrag ?? currentAntragMitArbeitszeit}
        antraege={filteredAntraege}
      />
    </>
  );
}
